(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["onefold-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('onefold-delivery')) {
    customElements.define(
      'onefold-delivery',
      class extends HTMLElement {
        connectedCallback() {
          const n = (key, fallback) => {
            const v = parseInt(this.dataset[key], 10);
            return Number.isFinite(v) ? v : fallback;
          };
          const addBusinessDays = (date, days) => {
            const d = new Date(date);
            let left = days;
            while (left > 0) {
              d.setDate(d.getDate() + 1);
              if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
            }
            return d;
          };
          const arrive = (processing, transit) => addBusinessDays(addBusinessDays(new Date(), processing), transit);
          const pMin = n('processingMin', 1), pMax = Math.max(pMin, n('processingMax', 3));
          const tMin = n('transitMin', 7), tMax = Math.max(tMin, n('transitMax', 15));
          const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
          const from = fmt.format(arrive(pMin, tMin));
          const to = fmt.format(arrive(pMax, tMax));
          const out = this.querySelector('[data-dates]');
          if (out) out.textContent = from === to ? from : `${from} – ${to}`;
          this.classList.add('is-ready');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
